<template>
  <div>
    <section v-for="(item, index) in $store.state.main.extras" :key="index">
      <div class="flex w-full mt-5">
        <div class="w-8/12">
          <h5 class="font-bold mb-3">{{ item.Description }}</h5>
          <p class="my-3">RM {{ item.Charge }} each per rental</p>
          <p class="mt-3">{{ item.AdditionalInfo }}</p>
        </div>
        <div class="w-4/12 flex items-center my-auto">
          <vs-input-number v-model="item.Quantity" />

        </div>
      </div>
      <vs-divider />
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    extras() {
      return this.$store.state.main.extras;
    }
  },
  methods: {
    getMatchingItem(code) {
      return this.$store.state.main.reservationData.Extras.find(item => item.Code === code);
    },
    updateQuantities() {
      const extras = this.$store.state.main.extras;
      const reservationExtras = this.$store.state.main.reservationData.Extras;

      extras.forEach(extra => {
        const match = reservationExtras.find(resExtra => resExtra.Code === extra.Code);
        if (match) {
          extra.Quantity = match.Quantity;
        }
      });
    }
  },
  created() {
    this.updateQuantities();
  }
};
</script>

<style scoped></style>
